// src/services/authService.js
import api from './api'

const normalizeEmail = (value) =>
    String(value || '')
        .trim()
        .toLowerCase()

export const authService = {
    login: async (credentials) => {
        try {
            const res = await api.post('/auth/login', {
                email: normalizeEmail(credentials.email || credentials.emailAddress),
                password: credentials.password,
            })

            const { token } = res.data || {}
            if (token) localStorage.setItem('token', token)

            await authService.refreshSession()

            return res.data
        } catch (error) {
            throw error
        }
    },

    register: async (userData) => {
        const res = await api.post('/auth/register', userData)

        const { token } = res.data || {}
        if (token) localStorage.setItem('token', token)

        await authService.refreshSession()

        return res.data
    },

    logout: async () => {
        try {
            await api.post('/auth/logout')
        } finally {
            localStorage.removeItem('token')
            localStorage.removeItem('session_user')
        }
        return { ok: true }
    },

    getProfile: async () => {
        return (await api.get('/auth/me')).data
    },

    updateProfile: async (userData) => {
        return (await api.post('/auth/me', userData)).data
    },

    uploadAvatar: async (file) => {
        const formData = new FormData()
        formData.append('avatar', file)

        return (await api.post('/auth/avatar', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })).data
    },

    refreshSession: async () => {
        const profile = (await api.get('/auth/me')).data
        localStorage.setItem('session_user', JSON.stringify(profile))
        return profile
    },
}

export default authService
